<template>
  <div class="hero-slider">
    <TransitionGroup name="fade" tag="div" class="slides-container">
      <div 
        v-for="(slide, index) in slides" 
        :key="slide.id"
        v-show="currentIndex === index"
        class="slide"
      >
        <div class="image-wrapper">
          <picture>
            <!-- Mobile Layout: Schermi fino a 767px -->
            <source 
              media="(max-width: 767px)" 
              :srcset="slide.mobileImage"
              type="image/webp"
              width="1080"
              height="1440"
            >
            <!-- Desktop Layout: Schermi da 768px in su -->
            <source 
              media="(min-width: 768px)" 
              :srcset="slide.image"
              type="image/webp"
              width="3198"
              height="1312"
            >
            <!-- Fallback obbligatorio per SEO e browser legacy -->
            <img 
              :src="slide.image" 
              :alt="slide.title"
              class="slide-image"
              :loading="index === 0 ? 'eager' : 'lazy'"
              :fetchpriority="index === 0 ? 'high' : 'auto'"
              decoding="async"
              width="3198"
              height="1312"
            >
          </picture>
          <div class="dark-overlay"></div>
        </div>
      </div>
    </TransitionGroup>

  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const slides = [
  {
    id: 1,
    image: '/images/hero/desktop/image-1.webp',
    mobileImage: '/images/hero/mobile/image-1.webp',
    title: 'Nuova Collezione T-Shirt',
    subtitle: 'Qualità premium e design minimalista per il tuo stile quotidiano.',
    buttonText: 'Sfoglia Collezione',
    link: '/t-shirt'
  },
  {
    id: 2,
    image: '/images/hero/desktop/image-2.webp',
    mobileImage: '/images/hero/mobile/image-2.webp',
    title: 'Edizioni Limitate',
    subtitle: 'Pezzi esclusivi creati in collaborazione con artisti indipendenti.',
    buttonText: 'Scopri Esclusive',
    link: '/t-shirt'
  },
  {
    id: 3,
    image: '/images/hero/desktop/image-3.webp',
    mobileImage: '/images/hero/mobile/image-3.webp',
    title: 'Sostenibilità al Primo Posto',
    subtitle: 'Ogni nostra t-shirt è realizzata in cotone organico al 100%.',
    buttonText: 'Chi Siamo',
    link: '/chi-siamo'
  }
]

const currentIndex = ref(0)
const intervalId = ref(null)
const SLIDE_DURATION = 5000

const startAutoScroll = () => {
  intervalId.value = setInterval(() => {
    nextSlide()
  }, SLIDE_DURATION)
}

const stopAutoScroll = () => {
  if (intervalId.value) {
    clearInterval(intervalId.value)
  }
}

const nextSlide = () => {
  currentIndex.value = (currentIndex.value + 1) % slides.length
}

const goToSlide = (index) => {
  currentIndex.value = index
  resetAutoScroll()
}

const resetAutoScroll = () => {
  stopAutoScroll()
  startAutoScroll()
}

onMounted(() => {
  startAutoScroll()
})

onBeforeUnmount(() => {
  stopAutoScroll()
})
</script>

<style scoped>
.hero-slider {
  position: relative;
  width: 100%;
  aspect-ratio: 3198 / 1312; /* Rapporto Desktop da specifiche (~2.44:1) */
  min-height: 400px;
  overflow: hidden;
  background-color: var(--dark-teal);
}

.slides-container {
  height: 100%;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  display: block;
}

.dark-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease, transform 1s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: scale(1.05);
}

.fade-leave-to {
  opacity: 0;
}

@media (max-width: 767px) {
  .hero-slider {
    aspect-ratio: 1080 / 1440; /* Rapporto Mobile da specifiche (3:4) */
    min-height: 500px; /* Altezza minima adeguata al formato verticale */
  }
}
</style>
